const authGuard = {
  beforeEnter: (to, from, next) => {
    if (!Laravel.auth_check || !Laravel.user) {

      let url = new URL(window.location.href);

      localStorage.setItem(
        "login_redirection",
        url
      );

      return next({ path: "/login" });
    }

    if (localStorage.getItem("login_redirection")) {
      localStorage.removeItem("login_redirection");
    }

    next();
  }
};

export { authGuard };
